import axios from "axios";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { CustomForm, CustomModal } from "../../components";
import {
  useFetchGameStatesQuery,
  useFetchProfilesQuery,
  useFetchAllSportsQuery,
  useFetchAllRafflesQuery,
  useFetchSingleCustomAdvertiserQuery,
  useFetchCollegesQuery,
  useFetchAllNewsNetQuery,
} from "../../store/api/apiSlice";
import { Input } from "../../ui";
import LeftSideAnimation from "../animations/LeftAndRightSideAnimation";
import "bootstrap/dist/css/bootstrap.min.css";
import swal from "sweetalert";
import { useTheme } from "../context/ThemeContext";
import { useForumContext } from "../../components/context/ForumContext";
import MyTeam from "../MyTeam/MyTeam";
import Skeleton from "react-loading-skeleton";
import VoteSection from "../VotesSection/VoteSection";
const RightSideNav = () => {
  const {
    setSelectedForum,
    updateSelectedSport,
    setSelectedSport,
    updateSelectedForum,
    updateSelectedSchool,
  } = useForumContext();
  const { data: NewLinkData } = useFetchAllNewsNetQuery();

  const { fgColor, bgColor } = useTheme();
  const { data: sportsData, error: ErrorSport } = useFetchAllSportsQuery();
  const navigate = useNavigate();
  const [initialSelectedSports, setInitialSelectedSports] = useState([]);
  const {
    data: rafflesData = { raffles: [] },
    isLoading: raffelLoading,
    refetch,
  } = useFetchAllRafflesQuery();

  const { data: profileData } = useFetchProfilesQuery();
  const college = profileData?.user.school_name;
  const { data: universitiesData } = useFetchCollegesQuery();
  const collegeList = universitiesData?.university || [];

  const Navigate = useNavigate();
  useEffect(() => {
    if (profileData && profileData.user) {
      const { favorite_sports = [] } = profileData.user;
      const favoriteSports = favorite_sports[0]
        ? JSON.parse(favorite_sports[0])
        : [];
      const selectedSports = favoriteSports
        .map((athlete) => athlete.name)
        .slice(0, 3)
        .concat(Array(3).fill(""))
        .slice(0, 3);
      setInitialSelectedSports(selectedSports);
      // console.log("initialSelectedSports", selectedSports);
    } else {
      // console.log("Profile data is not available yet.");
    }
  }, [profileData]);
  const getMatchedSports = () => {
    if (!sportsData || !sportsData.sports) return [];

    return initialSelectedSports
      .map((selectedSport) => {
        return sportsData.sports.find((sport) => sport.name === selectedSport);
      })
      .filter((sport) => sport);
  };

  const matchedSports = getMatchedSports();
  const matchedCollege = collegeList.find(
    (college) => college.name === profileData?.user?.school_name
  );

  let fgColorCode;
  if (matchedCollege) {
    fgColorCode = matchedCollege.fg_color_code;
  } else {
  }
  const {
    data: singleCustomAdvertiser,
    refetch: refetchSingleCustomAdvertiser,
  } = useFetchSingleCustomAdvertiserQuery(profileData?.user?.school_name, {
    skip: !profileData?.user?.school_name,
  });

  const newsAdvertiser = singleCustomAdvertiser?.advertisers?.find(
    (ad) => ad.type === "raffle"
  );
  const raffles = rafflesData.raffles;
  const [invitees, setInvitees] = useState([{ fname: "", lname: "" }]);
  const [isForumSelected, setIsForumSelected] = useState(false);
  const [isTop25Selected, setIsTop25Selected] = useState(false);
  const [isNetSelected, setIsNetSelected] = useState(false);

  const [isNetNews, setIsNetNews] = useState(false);
  const [selectedType, setSelectedType] = useState(null);
  const [isModalOpen2, setIsModalOpen2] = useState(false);
  const [isMyTeamSelected, setIsMyteamSelected] = useState(false);
  const [isInviteButtonDisabled, setIsInviteButtonDisabled] = useState(false);
  const handleAddInvitee = () => {
    setIsInviteButtonDisabled(false);
    setInvitees([...invitees, { fname: "", lname: "" }]);
  };
  const handleRemoveInvitee = (index) => {
    const newInvitees = invitees.filter((_, i) => i !== index);
    setInvitees(newInvitees);
  };

  const handleChange = (index, field, value) => {
    const newInvitees = [...invitees];
    newInvitees[index][field] = value;
    setInvitees(newInvitees);
  };

  const handleTypeClick = (type) => {
    setIsNetNews(true);
    setSelectedType(type);
    if (type === "top25") {
      setIsTop25Selected(true);
      setIsForumSelected(false);
      setIsMyteamSelected(false);
      setIsNetSelected(false);
    } else if (type === "net") {
      setIsNetSelected(true);
      setIsTop25Selected(false);
      setIsForumSelected(false);
      setIsMyteamSelected(false);
    }
  };
  const handleForumClick = () => {
    setIsForumSelected(true);
    setIsNetSelected(false);
    setIsTop25Selected(false);
    setIsNetNews(false);
    setIsMyteamSelected(false);
    updateSelectedForum("viewAll");
    setSelectedForum("viewAll");
  };
  const handleMyTeamClick = () => {
    setIsForumSelected(false);
    setIsNetNews(false);
    setIsNetSelected(false);
    setIsTop25Selected(false);
    setIsModalOpen2(true);
    setIsMyteamSelected(true);
  };
  const handleImageClickUrl = (sport) => {
    if (isForumSelected) {
      updateSelectedSchool(college);
      setSelectedSport(sport);
      updateSelectedSport(sport);
      navigate(`/forumlist`);
    } else if (isNetNews) {
      if (NewLinkData && NewLinkData.top_net_links) {
        const matchedLink = NewLinkData.top_net_links.find(
          (link) => link.type === selectedType && link.sports_name === sport
        );

        if (matchedLink) {
          window.open(matchedLink.resource_URL, "_blank");
        } else {
          toast.error("No Match Found");
        }
      }
    }
  };

  const sortedRaffles = [...raffles].sort(
    (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
  );

  const latestRaffle = sortedRaffles[0];
  const [show, setShow] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedField, setSelectedField] = useState("");
  const [generatedLink, setGeneratedLink] = useState("");
  const [generatedMessage, setGeneratedMessage] = useState("");
  const [description, setDescription] = useState("");
  const [step, setStep] = useState(0);

  const secretKey = process.env.REACT_APP_SECRET_KEY;
  const baseUrl = process.env.REACT_APP_SERVER_URL;

  const token = JSON.parse(localStorage.getItem("token"));
  const {
    data: fetchGameStates,
    isLoading,
    error,
  } = useFetchGameStatesQuery(token?.userId);

  const userCreatedat = JSON.parse(localStorage.getItem("user"))?.createdAt;

  useEffect(() => {
    const existingLink = localStorage.getItem("generatedInvitationLink");
    if (existingLink) {
      setGeneratedLink("");
    }
  }, []);

  const handleGenerateLink = async () => {
    if (
      invitees.some(
        (invitee) => invitee.fname.trim() === "" || invitee.lname.trim() === ""
      )
    ) {
      setTimeout(() => {
        swal({
          title: "",
          text: "Please fill in all the invitee names.",
          icon: "error",
          timer: 5000,
        });
      }, 1000);
      return;
    }
    const updatedInvitees = invitees.map((invitee) => ({
      ...invitee,
      invited: true,
    }));
    setInvitees(updatedInvitees);
    const inviteesData = invitees.map((invitee) => ({
      invitee_fname: invitee.fname,
      invitee_lname: invitee.lname.charAt(0),
    }));
    const body = {
      InviteesData: inviteesData,
      playgame: {
        inviter: profileData.user._id,
        invited_date: new Date().toLocaleDateString("en-CA"),
        invitee_clicked: false,
        invitee_signup: false,
        invitee_paid: false,
        is_email_success: false,
        invitee_response: false,
        invitee_response_datetime: "",
        invitee_profile_id: "",
        is_award_retained: false,
        is_charitable: false,
        charitableProgram: "",
      },
    };

    try {
      const token = JSON.parse(localStorage.getItem("token"));
      const xAuthToken = token ? token.token : null;
      const currentOrigin = window.location.origin;

      const response = await axios.post(
        `${baseUrl}/api/play-game/createOrUpdatePlayGame`,
        body,
        {
          headers: {
            "x-auth-token": xAuthToken,
            "secret-key": secretKey,
          },
        }
      );

      if (response.data.message) {
        const invitationLink = `${currentOrigin}/invitation/${response.data.updatedRecord.randomId}`;

        const invitees = response.data.addedinvitee;

        const inviteesNames = invitees
          .map((invitee) => `${invitee.invitee_fname} ${invitee.invitee_lname}`)
          .join(", ");

        const personalizedMessage = `Dear\n ${inviteesNames},\n\nI would like to invite you to join CSFA through the link below:\n${invitationLink}\n\nBest regards,\n${profileData?.user.firstName || "Your Name"
          }`;
        setGeneratedLink(invitationLink);
        setGeneratedMessage(personalizedMessage);
        localStorage.setItem("generatedInvitationLink", personalizedMessage);

        setTimeout(() => {
          swal({
            title: "",
            text: response.data.message,
            icon: "success",
            timer: 5000,
          });
        }, 1000);
        setIsInviteButtonDisabled(true);
      } else {
        toast.error("Unexpected response from server.");
      }
    } catch (error) {
      toast.error("Failed to send invites. Please try again.");
    }
  };

  const handleTextClick = () => {
    setSelectedField("text");
    setIsModalOpen(true);

    setStep(1);
  };

  const handleEmailClick = () => {
    setSelectedField("email");
    setIsModalOpen(true);
  };

  const userCreatedDateTime = new Date(userCreatedat);
  const gameDeadline = moment(userCreatedDateTime).add(1, "year").toDate();
  const currentDateTime = new Date();
  const timeLeftMilliseconds =
    gameDeadline.getTime() - currentDateTime.getTime();

  let formattedTimeLeft;

  if (timeLeftMilliseconds < 0) {
    formattedTimeLeft = "0D 0H 0M";
  } else {
    const duration = moment.duration(timeLeftMilliseconds);
    formattedTimeLeft = `${Math.floor(
      duration.asDays()
    )}D ${duration.hours()}H ${duration.minutes()}M`;
  }

  const handleClose = () => {
    setShow(false);
  };
  const resetStates = () => {
    setInvitees([{ fname: "", lname: "" }]);
    setIsInviteButtonDisabled(false);
    setGeneratedLink("");
    setGeneratedMessage("");
  };

  const handleModalClose = () => {
    resetStates();
    setIsModalOpen(false);
  };

  const handleCopyLink = () => {
    try {
      navigator.clipboard.writeText(generatedMessage);

      setTimeout(() => {
        swal({
          title: "",
          text: "Message copied to clipboard!",
          icon: "success",
          timer: 5000,
        });
        resetStates();
        setIsModalOpen(false);
      }, 1000);
    } catch (err) {
      const textArea = document.createElement("textarea");
      textArea.value = generatedMessage;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand("copy");
      document.body.removeChild(textArea);
      toast.success("Message copied to clipboard!");
    }
  };

  if (ErrorSport) {
    return <Navigate to="/login" />;
  }

  return (
    <>
      <CustomModal
        isOpen={isModalOpen}
        onClose={handleModalClose}
        style={{
          scrollbarColor: bgColor ? `${bgColor} #f1f1f1` : "#704fe6 #f1f1f1",
          scrollbarWidth: "thin",
        }}
      >
        <CustomForm className="customForm_cont">
          <>
            <h3
              className="rightSideNav_HeaderText"
            >
              Invite Recruit(s){" "}
            </h3>
            <hr className="rightSideNav_divider" />
            <p className="pb-2">
              <strong> Step 1:</strong> Enter First and Last name of each
              recruit. Click Invite Recruit(s).{" "}
            </p>
            <h3
              className="pb-2 rightSideNav_texth3"

            >
              Add the recruits you want to invite:
            </h3>
            {invitees.map((invitee, index) => (
              <div
                key={index}
                className="rightSideNav_MainDiv"
              >
                <div

                  className="col-4 rightSideNav_MainDiv2"
                >
                  <Input
                    placeholder="First Name"
                    label="First Name"
                    type="text"
                    value={invitee.fname}
                    onChange={(e) =>
                      handleChange(index, "fname", e.target.value)
                    }
                    style={{ marginRight: "10px" }}
                  />
                </div>
                <div

                  className="col-4 rightSideNav_MainDiv2"
                >
                  <Input
                    placeholder="Last Name"
                    label="Last Name"
                    type="text"
                    value={invitee.lname}
                    onChange={(e) =>
                      handleChange(index, "lname", e.target.value)
                    }
                    style={{ marginRight: "10px" }}
                  />
                </div>
                {invitee.invited ? (
                  <span className="rightSideNav_invitedSpan">Invited</span>
                ) : (
                  <span
                    className="rightSideNav_Not_invitedSpan"
                  ></span>
                )}

                <button
                  onClick={() => handleRemoveInvitee(index)}
                  className="Minus-btn rightSideNav_removeBtn"

                >
                  -
                </button>
              </div>
            ))}
            <div className="rightSideNav_addBtn_Div">
              <h5
                onClick={handleAddInvitee}
                variant="contained"
                fullWidth
                className="hoverable"
              >
                Add More
              </h5>
            </div>

            <div className="rightSideNav_InviteBtn">
              <Button
                onClick={handleGenerateLink}
                disabled={isInviteButtonDisabled}
                variant="contained"
                fullWidth
                className="btn-primary1"
                style={{ marginBottom: "15px", marginLeft: "0 !important" }}
              >
                Invite Recruit(s)
              </Button>
            </div>
            <p className="pb-2">
              <strong>Step 2:</strong> Customize and copy the message including
              the link. Close the popup.{" "}
            </p>
          </>

          <>
            <div className="rightSideNav_GenerateLink">
              <p>Link:</p>
              <p>{generatedLink}</p>
              <label>Generated Message:</label>
              <div
                className="rightSideNav_GenerateMsg"
              >
                <textarea
                  type="text"
                  value={generatedMessage}
                  readOnly
                  className="rightSideNav_textArea"
                />
                <Button
                  onClick={handleCopyLink}
                  variant="outlined"
                  size="small"
                  className="btn-primary rightSideNav_copyBtn"

                >
                  Copy
                </Button>
              </div>
              <p className="pb-2">
                <strong>Step 3:</strong>Open your favorite Text/Email app. Add
                Your Personalized message and include the copied text and send.
              </p>
            </div>
          </>
        </CustomForm>
      </CustomModal>
      <div>
        <div>
          {isLoading ? (
            <Skeleton height={150} />
          ) : (
            <div>
              <VoteSection />
            </div>
          )}
        </div>
      </div>
      {raffelLoading ? (
        <Skeleton height={300} />
      ) : (
        <div className="card">
          <div className="card-body">
            <LeftSideAnimation x={100}>
              <p className="broughttoyou2 rightSideNav_WeeklySponsor">
                WEEKLY SPONSORED GIVEAWAY DRAWING
              </p>
              <p
                className="ticketText rightSideNav_title"
                onClick={() => setShow(true)}

              >
                {latestRaffle?.title}
              </p>
            </LeftSideAnimation>
          </div>
        </div>
      )}

      {isLoading ? (
        <Skeleton height={300} />
      ) : (
        <div className="card">
          <div className="card-body">
            <div className="heading_box">
              <LeftSideAnimation x={100}>
                <h4
                  className="broughttoyou2 rightSideNav_sponsorgiveAway"

                >
                  Sponsor Giveaway - Brought to you by
                </h4>
              </LeftSideAnimation>
            </div>
            <LeftSideAnimation x={100}>
              {newsAdvertiser ? (
                <a
                  href={newsAdvertiser.url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    key={newsAdvertiser._id}
                    src={`${baseUrl}/${newsAdvertiser.bannerAdFile}`}
                    alt={newsAdvertiser.businessName}
                    className="broughtimage img-fluid px-3"
                  />
                </a>
              ) : (
                <h6 className="rightSideNav_NoAd">No ad for now.</h6>
              )}
            </LeftSideAnimation>
          </div>
        </div>
      )}

      <div className="card hiddenlg">
        <div className="card-body px-0">
          <div className="heading_box">
            <LeftSideAnimation>
              <h4 className="broughttoyou rightSideNav_Chalk_Talk ps-3" >
                Chalk Talk-Chat Room
              </h4>
            </LeftSideAnimation>
          </div>
          <div className="forum_div px-3">
            <LeftSideAnimation>
              <div
                className="rightSideNav_ForumDiv"
              >
                <div
                  style={{
                    padding: "10px",
                    backgroundColor: isForumSelected
                      ? "antiquewhite"
                      : "transparent",
                    borderRadius: isForumSelected ? "15px" : "0",
                  }}
                >
                  <Link to="#" className="forumlink" onClick={handleForumClick}>
                    FORUM{" "}
                  </Link>
                </div>
                <div
                  style={{
                    padding: "10px",
                    backgroundColor: isMyTeamSelected
                      ? "antiquewhite"
                      : "transparent",
                    borderRadius: isMyTeamSelected ? "15px" : "0",
                  }}
                >
                  <Link
                    to="#"
                    className="forumlink"
                    onClick={handleMyTeamClick}
                  >
                    MY TEAM
                  </Link>
                </div>
              </div>
            </LeftSideAnimation>
          </div>
          <MyTeam
            isModalOpen2={isModalOpen2}
            setIsModalOpen2={setIsModalOpen2}
          />
          <div
            className="mb-3 px-3 rightSideNav_MatchedSport"

          >
            {matchedSports.map((sport, index) => (
              <LeftSideAnimation x={-50}>
                <img
                  key={sport._id}
                  src={`${baseUrl}/${sport.sportsFile}`}
                  alt={sport.name}
                  className="chatimage22 rightSideNav_MatchedSportImg"

                  onClick={() => handleImageClickUrl(sport.name)}
                />
              </LeftSideAnimation>
            ))}
          </div>
          <div className="forum_div px-3">
            <div
              className="rightSideNav_Top25"
            >
              <div
                style={{
                  padding: "10px",
                  backgroundColor: isTop25Selected
                    ? "antiquewhite"
                    : "transparent",
                  borderRadius: isTop25Selected ? "15px" : "0",
                }}
              >
                <Link
                  className="forumlink f14 p73"
                  onClick={() => handleTypeClick("top25")}
                >
                  TOP 25
                </Link>
              </div>
              <div
                style={{
                  padding: "10px",
                  backgroundColor: isNetSelected
                    ? "antiquewhite"
                    : "transparent",
                  borderRadius: isNetSelected ? "15px" : "0",
                }}
              >
                <Link
                  className="forumlink f14"
                  onClick={() => handleTypeClick("net")}
                >
                  Net’l Score
                </Link>
              </div>
            </div>
          </div>
        </div>
        {isLoading ? (
          <Skeleton height={300} />
        ) : (
          <div
            className="card "
            id="purpleright"
            style={{ backgroundColor: bgColor, color: fgColor }}
          >
            <div className="card-body ">
              <div className="purplecardheading">
                <LeftSideAnimation x={100}>
                  <h4 className="gamestatustext">Your Play The Game Status</h4>
                </LeftSideAnimation>
              </div>
              <LeftSideAnimation x={100}>
                <p className="time-left">Time left in the Game</p>
              </LeftSideAnimation>
              <LeftSideAnimation x={100}>
                <h6 className="info-label2">{formattedTimeLeft}</h6>
              </LeftSideAnimation>
              <div className="row mt-4">
                <div className="col-6">
                  <LeftSideAnimation x={100}>
                    <p className="info-label">Total Recruits</p>
                  </LeftSideAnimation>
                  <LeftSideAnimation x={100}>
                    <h6 className="info-label2">
                      {fetchGameStates?.stats?.totalInvitees}
                    </h6>
                  </LeftSideAnimation>
                </div>
                <div className="col-6">
                  <LeftSideAnimation x={100}>
                    <p className="info-label">Signed Recruits</p>
                  </LeftSideAnimation>
                  <LeftSideAnimation x={100}>
                    <h6 className="info-label2">
                      {fetchGameStates?.stats?.totalSignups}
                    </h6>
                  </LeftSideAnimation>
                </div>
              </div>
              <div className="row mt-3">
                <div className="col-6">
                  <LeftSideAnimation x={100}>
                    <p className="info-label">Status level</p>
                  </LeftSideAnimation>
                  <LeftSideAnimation x={100}>
                    <h6 className="info-label2">
                      {fetchGameStates?.stats?.userPTGlevel}
                    </h6>
                  </LeftSideAnimation>
                </div>
                <div className="col-6">
                  <LeftSideAnimation x={100}>
                    <p className="info-label">Qty to reach team</p>
                  </LeftSideAnimation>
                  <LeftSideAnimation x={100}>
                    <h6 className="info-label2">
                      {(fetchGameStates?.stats?.totalInvitees ?? 0) -
                        (fetchGameStates?.stats?.totalSignups ?? 0)}
                    </h6>
                  </LeftSideAnimation>
                </div>
              </div>
            </div>
            <div
              className="card-footer text-center text-white rightSideNav_timeLeft"

            >
              <LeftSideAnimation x={100}>
                {formattedTimeLeft !== "0D 0H 0M" && (
                  <button
                    className="btn btn-light2 w-100"
                    onClick={handleTextClick}
                  >
                    Invite Recruit (s)
                  </button>
                )}
              </LeftSideAnimation>
            </div>
          </div>
        )}
      </div>


      <CustomModal isOpen={show} onClose={handleClose}>
        <div className="rightSideNav_CustomModal_weekly">
          <h3 className="rightSideNav_CustomModal_header">WEEKLY GIVEAWAY DRAWING</h3>
          <p className="neilsonmodaltext" >
            We’d like to thank {latestRaffle?.sponsorName} for sponsoring this
            weeks raffle : {latestRaffle?.title}
          </p>

          <div className="table-responsive py-3">
            <p>
              <strong className="rightSideNav_CustomModal_Text2">Narrative:</strong>{" "}
              <div>{latestRaffle?.narrative}</div>
            </p>

            <p>
              <strong className="rightSideNav_CustomModal_Text2">Description:</strong>
              <div>{latestRaffle?.description}</div>
            </p>

            <div className="rightSideNav_CustomModal_TextDiv">
              <p>
                <strong className="rightSideNav_CustomModal_Text2">Entry Date:</strong>
                <div>
                  {moment(latestRaffle?.entryDate).format("MMMM Do, YYYY")}
                </div>{" "}
              </p>{" "}
              <p>
                <strong className="rightSideNav_CustomModal_Text2">Drawing Date:</strong>{" "}
                <div>{latestRaffle?.entryCutOff}</div>
              </p>
            </div>
            <div className="rightSideNav_CustomModal_TextDiv2">
              <p className="rightSideNav_CustomModal_Text3">
                {" "}
                <strong className="rightSideNav_CustomModal_Text2">Sponsor Link:</strong>
                <a
                  href={latestRaffle?.sponsorLink}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {latestRaffle?.sponsorLink}
                </a>{" "}
              </p>
              <img

                src={`${baseUrl}/${latestRaffle?.sponsorLogoImage}`}
                alt="Neilson"
                className="img-fluid neilsonImageModal rightSideNav_CustomModal_img4"
              />
            </div>
          </div>

          <p className="modaltextFooter">{latestRaffle?.notes || ""}</p>
        </div>
      </CustomModal>
    </>
  );
};

export default RightSideNav;
